import { extend } from 'lodash'

import CustomError from '../Utilities/CustomError'

import * as EntityConstants from './EntityConstants'
import Layer from './Layer'

export default class EllipticalArc {
    constructor(json) {
        this['$type'] = json['$type']
        this.startPoint = undefined
        this.endPoint = undefined
        this.layer = undefined
        this.isLineTypeSolid = undefined
        this.type = undefined
        this.toSvg = undefined
        this.radiusX = undefined
        this.radiusY = undefined
        this.rotation = undefined
        this.isLargeArc = undefined
        this.direction = undefined
        this.lineApproximation = []

        const jsonValid =
            json &&
            Object.prototype.hasOwnProperty.call(json, 'layer') &&
            Object.prototype.hasOwnProperty.call(json, 'isLineTypeSolid') &&
            Object.prototype.hasOwnProperty.call(json, 'type') &&
            Object.prototype.hasOwnProperty.call(json, 'startPoint') &&
            Object.prototype.hasOwnProperty.call(json, 'endPoint') &&
            Object.prototype.hasOwnProperty.call(json, 'radiusX') &&
            Object.prototype.hasOwnProperty.call(json, 'radiusY') &&
            Object.prototype.hasOwnProperty.call(json, 'rotation') &&
            Object.prototype.hasOwnProperty.call(json, 'isLargeArc') &&
            Object.prototype.hasOwnProperty.call(json, 'direction') &&
            Object.prototype.hasOwnProperty.call(json, 'lineApproximation')

        if (jsonValid) {
            extend(this, json)
            this.layer = new Layer(json.layer)
        } else {
            throw new CustomError('Invalid json supplied', 'InvalidJSONError')
        }
    }

    // getSvgPathStr(lastPt) {
    //     let pathStr = ''
    //     const lastPtMeetsStartPoint =
    //         lastPt &&
    //         Math.abs(lastPt.x - this.startPoint.x) < EntityConstants.POINT_COMPARISON_PRECISION &&
    //         Math.abs(lastPt.y - this.startPoint.y) < EntityConstants.POINT_COMPARISON_PRECISION

    //     if (!lastPt || !lastPtMeetsStartPoint) {
    //         pathStr += !lastPtMeetsStartPoint ? ' ' : ''
    //         pathStr += 'M' + this.startPoint.x + ' ' + this.startPoint.y
    //     }
    //     pathStr += ' A' + this.radiusX + ' ' + this.radiusY + ' ' + (this.rotation * 180/Math.PI) + ' ' + (this.isLargeArc ? 0 : 1) + ' ' + (this.direction === 'ClockWise' ? 0 : 1) + this.endPoint.x + ' ' + this.endPoint.y
    //     return pathStr
    // }
    getSvgPathStr(lastPt) {
        let pathStr = ''
        const lastPtMeetsStartPoint =
            lastPt &&
            Math.abs(lastPt.x - this.lineApproximation[0].startPoint.x) < EntityConstants.POINT_COMPARISON_PRECISION &&
            Math.abs(lastPt.y - this.lineApproximation[0].startPoint.y) < EntityConstants.POINT_COMPARISON_PRECISION

        if (!lastPt || !lastPtMeetsStartPoint) {
            pathStr += !lastPtMeetsStartPoint ? ' ' : ''
            pathStr += 'M' + this.lineApproximation[0].startPoint.x + ' ' + this.lineApproximation[0].startPoint.y
        }

        this.lineApproximation.forEach((line) => {
            pathStr += ' L' + line.endPoint.x + ' ' + line.endPoint.y
        })

        return pathStr
    }
}

EllipticalArc.ToolpathType = 'DtoEllipticalArc'
